import React, { useReducer, createContext } from 'react'
import { SET_VIDEO_INPUT, SET_AUDIO_INPUT, SET_AUDIO_OUTPUT, SET_DEVICES } from 'constants/devices'

const DevicesStateContext = createContext()
const DevicesDispatchContext = createContext()

const initialState = {
  videoInput: null,
  audioInput: null,
  audioOutput: null,
  videoInputs: [],
  audioInputs: [],
  audioOutputs: [],
}

function reducer(state, action) {
  switch (action.type) {
    case SET_VIDEO_INPUT:
      return {
        ...state,
        videoInput: action.videoInput,
      }
    case SET_AUDIO_INPUT:
      return {
        ...state,
        audioInput: action.audioInput,
      }
    case SET_AUDIO_OUTPUT:
      return {
        ...state,
        audioOutput: action.audioOutput,
      }
    case SET_DEVICES: {
      const { videoInputs, audioInputs, audioOutputs } = action
      return {
        ...state,
        videoInputs,
        audioInputs,
        audioOutputs,
        videoInput: state.videoInput || videoInputs?.[0]?.deviceId,
        audioInput: state.audioInput || audioInputs?.[0]?.deviceId,
        audioOutput: state.audioOutput || audioOutputs?.[0]?.deviceId,
      }
    }
    default:
      throw new Error()
  }
}

const DevicesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <DevicesStateContext.Provider value={state}>
      <DevicesDispatchContext.Provider value={dispatch}>{children}</DevicesDispatchContext.Provider>
    </DevicesStateContext.Provider>
  )
}

export { DevicesProvider, DevicesStateContext, DevicesDispatchContext }
